/**
 * Created by Andrey Popov on 12/1/20.
 */

const ChatMessage = function () {
};

ChatMessage.fromData = function (messageData) {
    const message = new ChatMessage();

    message.id = messageData.id;
    message.userId = messageData.userId;
    message.postDate = messageData.postDate;
    message.message = messageData.message;
    message.isResponse = messageData.isResponse;
    message.readByUser = messageData.readByUser;
    message.tag = messageData.tag;
    message.status = messageData.status;
    message.dialogueId = messageData.dialogueId;

    message.type = ChatMessage.MESSAGE_TYPE.CHAT;
    return message;
};

ChatMessage.createServiceMessage = function (text, id) {
    const message = new ChatMessage();
    message.id = id || `service_${text.localize || text}`;
    message.message = text;
    message.type = ChatMessage.MESSAGE_TYPE.SERVICE;
    return message;
};

ChatMessage.createSeparator = function (id) {
    const message = new ChatMessage();
    message.id = `separator_${id}`;
    message.type = ChatMessage.MESSAGE_TYPE.SEPARATOR;
    return message;
};

ChatMessage.createTemporaryMessage = function (text) {
    const message = new ChatMessage();
    message.id = `tmp_${text}`;
    message.message = text;
    message.type = ChatMessage.MESSAGE_TYPE.TEMPORARY;
    message.postDate = new Date().toString();
    return message;
};

ChatMessage.prototype.hasGift = function () {
    return this.tag === "gift" || this.tag === "takengift";
};

ChatMessage.prototype.isGiftTaken = function () {
    return this.tag === "takengift";
};

ChatMessage.prototype.isTurningOnConsoleStream = function () {
    return this.tag === "stream_on";
};

ChatMessage.prototype.isTurningOffConsoleStream = function () {
    return this.tag === "stream_off";
};

ChatMessage.prototype.isFromActiveOrUnreadDialogue = function () {
    if (cleverapps.chat.activeDialogueId === this.dialogueId) {
        return true;
    }

    const activeDialogueId = (cleverapps.chat.getLastMessage() || {}).dialogueId;
    return cleverapps.chat.wasUnreadMessages && this.dialogueId === activeDialogueId;
};

ChatMessage.prototype.isApplicable = function () {
    this.parseGift();

    if (this.metha) {
        if (this.metha.farm) {
            const buildingId = parseInt(this.metha.farm.building);
            const building = cleverapps.meta.getSelectedLocation().buildings[buildingId];
            const questId = parseInt(this.metha.farm.quest);

            if (!building || questId >= building.quests.length) {
                return false;
            }
        }
    }

    if (this.presents) {
        if (this.presents.expedition) {
            if (cleverapps.meta.listActiveLocations().indexOf(this.presents.expedition) === -1) {
                return false;
            }
        }
        if (this.presents.unit) {
            const unit = this.presents.unit;
            if (!Families[unit.code] || !Families[unit.code].units[unit.stage]) {
                return false;
            }
        }
        if (Object.keys(this.presents).filter((type) => type !== "expedition").length === 0) {
            return false;
        }
    }

    return true;
};

ChatMessage.prototype.parseGift = function () {
    if (this.parsed) {
        return;
    }
    this.parsed = true;

    const gifts = JSON.parse(this.message);

    if (gifts.presents) {
        const reward = this.presents = {};

        if (gifts.expedition) {
            reward.expedition = gifts.expedition;
        }

        gifts.presents.forEach((present) => {
            if (typeof present !== "object" || present.type === undefined || present.amount === undefined) {
                return;
            }

            let name = present.type;

            // migration from old present types
            if (name === "coins") {
                name = "soft";
            } else if (name === "gold") {
                name = "hard";
            } else if (name === "lives2") {
                name = "lives";
            }

            if (["hard", "unlimitedLives", "stars", "exp", "lives", "soft", "wands", "worker", "unit", "growthFund", "noAds", "orderStar", "stickers", "joker", "mission", "seasonPassPoints", "seasonPassVip", "seasonPassSuper"].indexOf(name) === -1
                && name.indexOf("booster") !== 0 && name.indexOf("hl") !== 0 && name.indexOf("stickers2") !== 0) {
                return;
            }
            const amount = present.amount;
            if (name.indexOf("booster") === 0) {
                if (reward.boosters === undefined) {
                    reward.boosters = [];
                }
                reward.boosters[parseInt(name.replace("booster", ""))] = amount;
            } else if (name === "unlimitedLives") {
                reward.unlimitedLives = `${amount} hour`;
            } else if (name === "worker") {
                reward.worker = `${amount} hour`;
            } else if (name.indexOf("hl") !== -1) {
                if (!reward.herolevels) {
                    reward.herolevels = [];
                }
                reward.herolevels.push([name.replace("hl", ""), present.amount]);
            } else if (name === "unit") {
                reward.unit = {
                    code: present.code,
                    stage: present.stage,
                    amount: amount || 1
                };
            } else if (name === "stars") {
                reward.locationProgress = amount;
            } else if (name === "mission") {
                reward.mission = {
                    missionType: present.missionType,
                    amount: amount || 1
                };
            } else {
                if (RewardTypes[name] && RewardTypes[name].parse && cleverapps.toArray(RewardTypes[name].parse(amount, {})).length === 0) {
                    return;
                }
                reward[name] = amount;
            }
        });
    } else if (gifts.progress) {
        this.progress = gifts.progress;
    } else if (gifts.restoreProgressId) {
        this.restoreProgressId = gifts.restoreProgressId;
    } else if (gifts.metha) {
        this.metha = gifts.metha;
    } else if (gifts.harvested) {
        this.harvested = gifts.harvested;
    }
};

ChatMessage.MESSAGE_TYPE = {
    CHAT: 0,
    SERVICE: 1,
    TEMPORARY: 2,
    SEPARATOR: 3
};
